// use-pop-modal.ts — Layout/modal-stack, sync action
//
//

import { useCallback } from 'react';
import { useModalStackContext } from './modal-stack-context';

export function usePopModal(): (id?: string) => boolean {
  const modalStack = useModalStackContext();
  return useCallback((id?: string) => modalStack.pop(id), [modalStack]);
}
